import React, { useEffect,useState } from 'react'
import { getReserves,getBalanceAndSymbol } from '../../functions/dexfunctions'
import AddLiquidity from './AddLiquidity';
import RemoveLiquidity from './RemoveLiquidity';
import Rewards from './Rewards';
import { useParams } from "react-router-dom";
// Solana removed
export default function Liquidity({token,signer,dataToken}) {
  const {chain,tokenAddress } = useParams();
  
  // Transaction path functions for different operations
  const getAddLiquidityTransactionPath = () => {
    return [
      "1. Approve Token (Once)",
      "2. Add Liquidity"
    ];
  };

  const getRemoveLiquidityTransactionPath = () => {
    return [
      "1. Approve LP Tokens (Once)",
      "2. Remove Liquidity"
    ];
  };

  const addLiquidityTransactionPath = getAddLiquidityTransactionPath();
  const removeLiquidityTransactionPath = getRemoveLiquidityTransactionPath();

  const ethAddress = "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2";
  const symbolNative = "ETH";
    const [reserve, setReserve] = useState(null);
    const [ethBalance,setethBalance] = useState(null)
    const [tokenBalance,settokenBalance] = useState(null)
    const [activeTab, setActiveTab] = useState('add');
    const [loading, setLoading] = useState(true)
    const [isRotating, setIsRotating] = useState(false);
    const handleClick = () => {
      refreshInfo();
      setIsRotating(true);
    };
    const refreshInfo = async () => {
      fetchLiquidity()
      getBalances()
    }
    const fetchLiquidity = async () => {
        try {
          //console.log(ethAddress,token)
          const data = await getReserves(ethAddress,token,signer,chain)
          //console.log(data)
          setReserve(data)
          setLoading(false)

        } catch (error) {
          console.error("Error fetching Native price:", error);
        }
    };
    const getBalances = async () => {
      try{
        const tokenbal = await getBalanceAndSymbol(token,ethAddress,signer)
        const ethbal = await getBalanceAndSymbol(ethAddress,ethAddress,signer)
        setethBalance(ethbal)
        settokenBalance(tokenbal)
      }catch(e){
        console.log(e)
      }
    }
    useEffect(() => {
        fetchLiquidity()
        getBalances()
    },[])
return (

<div className="mb-4 w-full h-auto flex flex-col items-center justify-start bg-transparent px-4 sm:px-8">
  {loading === true ? 
    <div className='flex items-center justify-center w-full min-h-[90vh]'>
      <div className="w-full h-full justify-center items-center flex" role="status">
        <svg aria-hidden="true" className="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-gray-600 dark:fill-gray-300" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
        </svg>
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  :
  <>
    {/* Header & Pool Info */}
    {reserve && (
      <div className="w-full flex flex-col items-center">
        {/* Header Card */}
        <div className="bg-gradient-to-b from-[#ffffff09] to-[#ffffff05] border border-white/10 rounded-xl shadow-xl px-6 sm:px-10 py-8 flex flex-col gap-2 relative w-full max-w-[700px] mx-auto mt-8 mb-8 transition-shadow duration-300">
          {/* Token Pair Row with Info and Refresh */}
          <div className="flex items-center justify-center gap-3 mb-2 mt-2 relative w-full">
            {/* Info Button */}
            <div className="relative group mr-2">
              <svg className="w-5 h-5 text-gray-400 cursor-pointer" fill="currentColor" viewBox="0 0 20 20">
                <path d="M18 10c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zM9 7v2h2V7H9zm0 4v4h2v-4H9z" />
              </svg>
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 w-64 p-2 bg-[#0e1018] border border-white/15 text-white text-xs rounded-lg hidden group-hover:block transition-opacity duration-200 font-[300] z-20">
                In an automated market maker (AMM), liquidity enables decentralized token swaps by creating token pools provided by users, called liquidity providers (LPs). These pools ensure tokens are available for trading and determine prices using mathematical formulas.<br/><br/>
                <span className="text-white/80">Liquidity plays a crucial role by:</span><br/>
                <span className="text-white/60">• Enabling Trades: Pools allow traders to exchange tokens without a counterparty.<br/>
                • Reducing Slippage: Larger pools minimize price changes during swaps.<br/>
                • Rewarding LPs: LPs earn fees from every trade in their pool, incentivizing participation.</span>
              </div>
            </div>
            {/* ETH Logo */}
            <img src={'/eth.svg'} className='w-5 h-5 sm:w-10 sm:h-10 rounded-full border-2 border-white/10' />
            <span className="text-xs sm:text-2xl font-bold text-white">{symbolNative}</span>
            <span className="text-xs sm:text-xl font-bold text-white">/</span>
            <img src={dataToken.logo} className='w-5 h-5 sm:w-10 sm:h-10 rounded-full border-2 border-white/10' />
            <span className="text-xs sm:text-2xl font-bold text-white">{dataToken.symbol}</span>
            <span className="ml-1 sm:ml-4 px-1 sm:px-2 py-1 rounded bg-white/10 text-xs text-white font-semibold border border-white/10 flex items-center gap-1 sm:gap-2">
              {chain.toUpperCase()}
            </span>
            {/* Refresh Button OUTSIDE chain box */}
            <button className="ml-1 sm:ml-2 opacity-80 hover:opacity-100 group border border-white/10 bg-white/5 hover:bg-yellow-100/10 hover:border-yellow-100/50 rounded-full p-1 sm:p-1.5 transition-colors duration-200 flex items-center justify-center" onClick={handleClick} title="Refresh pool info">
              <img
                src="/refresh2.svg"
                className={`h-[12px] w-[12px] sm:h-[15px] sm:w-[15px] ${isRotating ? 'rotate-once' : ''}`}
                onAnimationEnd={() => setIsRotating(false)}
                alt="Refresh"
              />
              <span className="absolute -top-7 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition bg-black/90 text-white text-xs px-2 py-1 rounded shadow-lg">Refresh</span>
            </button>
          </div>
          {/* Stats Cards */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-4 mt-4 w-full">
            <div className="rounded-xl bg-gradient-to-b from-[#23283a] to-[#181c24] border border-white/10 p-2 sm:p-4 flex flex-col items-center">
              <div className="flex gap-2 items-center font-[600] text-white/80 text-[12px] sm:text-[15px]"><img src={'/eth.svg'} className='w-4 h-4 sm:w-5 sm:h-5' />{symbolNative}</div>
              <div className="text-lg sm:text-2xl font-bold text-white mt-1">{reserve[0]}</div>
              <div className="text-xs text-white/40 mt-1">Pool Reserve</div>
            </div>
            <div className="rounded-xl bg-gradient-to-b from-[#23283a] to-[#181c24] border border-white/10 p-2 sm:p-4 flex flex-col items-center">
              <div className="flex gap-2 items-center font-[600] text-white/80 text-[12px] sm:text-[15px]"><img src={dataToken.logo} className='w-4 h-4 sm:w-5 sm:h-5 rounded-full' />{dataToken.symbol}</div>
              <div className="text-lg sm:text-2xl font-bold text-white mt-1">{reserve[1]}</div>
              <div className="text-xs text-white/40 mt-1">Pool Reserve</div>
            </div>
            <div className="col-span-2 sm:col-span-1 rounded-xl bg-gradient-to-b from-[#23283a] to-[#181c24] border border-white/10 p-2 sm:p-4 flex flex-col items-center">
              <div className="text-white/80 text-[12px] sm:text-[15px] font-[600]">Your LP Tokens</div>
              <div className="text-lg sm:text-2xl font-bold text-white mt-1 truncate max-w-[140px] sm:max-w-[180px] cursor-pointer relative group"
                title={reserve[2]}
                onClick={() => {navigator.clipboard.writeText(reserve[2])}}>
                {Number(reserve[2]).toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 8})}
                <span className="absolute left-1/2 -translate-x-1/2 top-full mt-1 scale-0 group-active:scale-100 group-hover:scale-100 transition bg-black/90 text-white text-xs px-2 py-1 rounded shadow-lg z-30">Click to copy full value</span>
              </div>
              <div className="text-xs text-white/40 mt-1">{dataToken.symbol}-{symbolNative} LP</div>
            </div>
          </div> {/* end stats cards */}
        </div> {/* end main card */}
        {/* Tabs */}
        <div className="flex justify-center mt-2 mb-2 w-full max-w-[700px] mx-auto">
          <div className="flex bg-white/5 rounded-full shadow border border-white/10 px-2 py-1 gap-1 sm:gap-2 w-full justify-center">
            <button
              onClick={() => setActiveTab('add')}
              className={`flex items-center gap-1 sm:gap-2 px-2 sm:px-6 py-2 rounded-full text-[11px] sm:text-[15px] font-semibold transition-all duration-150
                ${activeTab === 'add' ? 'bg-green-400/10 text-gray-300 border-green-400/40 border' : 'text-white/60 bg-white/0 border border-white/10 hover:bg-green-400/10 hover:border-green-400/40'}
              `}
            >
              <span role="img" aria-label="Add">➕</span> <span className="hidden sm:inline">Add Liquidity</span><span className="sm:hidden">Add</span>
            </button>
            <button
              onClick={() => setActiveTab('remove')}
              className={`flex items-center gap-1 sm:gap-2 px-2 sm:px-6 py-2 rounded-full text-[11px] sm:text-[15px] font-semibold transition-all duration-150
                ${activeTab === 'remove' ? 'bg-red-400/10 text-gray-300 border-red-400/40 border' : 'text-white/60 bg-white/0 border border-white/10 hover:bg-red-400/10 hover:border-red-400/40'}
              `}
            >
              <span role="img" aria-label="Remove">➖</span> <span className="hidden sm:inline">Remove Liquidity</span><span className="sm:hidden">Remove</span>
            </button>
            <button
              onClick={() => setActiveTab('rewards')}
              className={`flex items-center gap-1 sm:gap-2 px-2 sm:px-6 py-2 rounded-full text-[11px] sm:text-[15px] font-semibold transition-all duration-150
                ${activeTab === 'rewards' ? 'bg-yellow-400/10 text-gray-300 border-yellow-400/40 border' : 'text-white/60 bg-white/0 border border-white/10 hover:bg-yellow-400/10 hover:border-yellow-400/40'}
              `}
            >
              <span role="img" aria-label="Earnings">💰</span> <span className="hidden sm:inline">Earnings</span><span className="sm:hidden">Earnings</span>
            </button>
          </div>
        </div>
        {/* Content Area */}
        <div className="w-full max-w-[700px] mx-auto bg-gradient-to-b from-[#ffffff09] to-[#ffffff05] border border-white/10 rounded-2xl shadow-xl p-6 sm:p-10 mt-4 mb-4">
          {activeTab === 'add' && (
            <AddLiquidity 
              reserve={reserve} 
              dataToken={dataToken} 
              tokenAddress={token} 
              signer={signer} 
              balance={[tokenBalance,ethBalance]} 
              chain={chain}
              transactionPath={addLiquidityTransactionPath}
            />
          )}
          {activeTab === 'remove' && (
            <RemoveLiquidity 
              reserve={reserve} 
              dataToken={dataToken} 
              tokenAddress={token} 
              signer={signer} 
              chain={chain}
              transactionPath={removeLiquidityTransactionPath}
            />
          )}
          {activeTab === 'rewards' && (
            <Rewards token={token} signer={signer} chain={chain} />
          )}
        </div> {/* end content area */}
      </div>
    )}
  </>
  }
</div>
)
}
